// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34b6166d","453":"80f1bfeb","732":"15bd5e5f"}[chunkId] + ".chunk.js";
};